module.exports = __webpack_public_path__ + "media/images/pc/stores/umeda/umeda_concept_01-40221d0bd31df37f0c26807c766ffd8b.jpg";